import { CounselingFormat, HomeBuyerCounseling } from 'constants/loanApplication';
import { getConditionalObject } from 'utils/data';

export const normalizeForm = ({ form, entityId }) => {
  const {
    homeBuyerCounseling,
    counselingFormat,
    counselingOtherDescription,
    formatOtherDescription,
  } = form[entityId]?.declarations?.homeCounseling ?? {};

  const isHomeBuyerOther = homeBuyerCounseling?.value === HomeBuyerCounseling.OTHER;
  const isCounselingOther = counselingFormat?.value === CounselingFormat.OTHER;

  return {
    ...form,
    [entityId]: {
      ...form[entityId],
      declarations: {
        ...form[entityId]?.declarations,
        homeCounseling: {
          homeBuyerCounseling,
          ...getConditionalObject(isHomeBuyerOther, {
            counselingOtherDescription,
          }),

          counselingFormat,
          ...getConditionalObject(isCounselingOther, {
            formatOtherDescription,
          }),
        },
      },
    },
  };
};
